import React, { useEffect, useRef, useState } from "react";
import BIDButton from "../../components/reusable/BIDButton/BIDButton";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/pnudBook.json";
import miscText from "../../utils/text/misc.json";
import PNUDTitleSection from "../../components/reusable/PNUDTitleSection/PNUDTitleSection";
import PNUDSectionTitle from "../../components/reusable/PNUDSectionTitle/PNUDSectionTitle";
import "./PNUDBook.css";
import { Carousel, Row, Col, Divider } from "antd";
import PNUDCarouselVideoCard from "../../components/reusable/PNUDCarouselVideoCard/PNUDCarouselVideoCard";
import PNUDAcceptance from "../../components/graphs/PNUDAcceptance/PNUDAcceptance";
import PNUDSocialServices from "../../components/graphs/PNUDSocialServices/PNUDSocialServices";
import PNUDEconomicContribution from "../../components/graphs/PNUDEconomicContributions/PNUDEconomicContributions";
import PNUDDiversity from "../../components/graphs/PNUDDiversity/PNUDDiversity";
import PNUDCrime from "../../components/graphs/PNUDCrime/PNUDCrime";
import VIDEOS from "../../utils/PNUD/videos.json";
import PNUDVideoCard from "../../components/reusable/PNUDVideoCard/PNUDVideoCard";

export default function PNUDBook() {
  const { language } = useCurrentLanguage();

  const carouselRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedVideoType, setSelectedVideoType] = useState(0);

  function toNext() {
    setCurrentSlide((currentSlide + 1) % 3);
  }

  function toPrev() {
    setCurrentSlide(currentSlide === 0 ? 2 : currentSlide - 1);
  }

  function toSlide(index) {
    setCurrentSlide(index);
  }

  function handleVideosInfoClick() {
    setSelectedVideoType(0);
  }

  function handleVideosEmoClick() {
    setSelectedVideoType(1);
  }

  useEffect(() => {
    let legendItemList = document.getElementsByClassName("main-videos-item");

    for (let i = 0; i < legendItemList.length; i++) {
      let item = legendItemList.item(i);
      item.classList.remove("pnud-carousel-legend-active");
    }

    legendItemList
      .item(currentSlide)
      .classList.add("pnud-carousel-legend-active");

    carouselRef.current.goTo(currentSlide);
  }, [currentSlide]);

  useEffect(() => {
    let legendItemList = document.getElementsByClassName("videos-item");

    for (let i = 0; i < legendItemList.length; i++) {
      let item = legendItemList.item(i);
      item.classList.remove("pnud-carousel-legend-active");
    }

    legendItemList
      .item(selectedVideoType)
      .classList.add("pnud-carousel-legend-active");
  }, [selectedVideoType]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  return (
    <div className="pnud-section-container">
      <div className="pnud-section-title">
        <PNUDTitleSection
          title1={TEXT["title1"][language]}
          title2={TEXT["title2"][language]}
          descriptionParagraphs={TEXT["description"][language]}
          image="pnud_front.png"
          callToActionElement={
            <>
              <div
                className="pnud-section-report-button"
                style={{ marginBottom: "10px" }}
              >
                <a
                  href="https://publications.iadb.org/es/un-mundo-mejor-para-la-poblacion-migrante-en-america-latina-y-el-caribe"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <BIDButton
                    text={miscText["downloadBook"][language]}
                    type={"light"}
                    size={"medium"}
                  />
                </a>
              </div>
              <div className="pnud-section-report-button">
                <a href="/AnexoEnLínea.zip" download>
                  <BIDButton
                    text={miscText["downloadAnnex"][language]}
                    type={"light"}
                    size={"medium"}
                  />
                </a>
              </div>
            </>
          }
        />
      </div>
      <div className="pnud-content">
        <div className="pnud-content-section ">
          <PNUDSectionTitle text={TEXT["experiment"]["title"][language]} />
          <p>{TEXT["experiment"]["description"][language]}</p>
          <div className="pnud-carousel-legend">
            <button className="noformat-button" onClick={() => toSlide(0)}>
              <h4
                id="carousel-legend-0"
                className="pnud-carousel-legend-item main-videos-item"
              >
                {TEXT["sections"]["informative"][language]}
              </h4>
            </button>
            <button className="noformat-button" onClick={() => toSlide(1)}>
              <h4
                id="carousel-legend-1"
                className="pnud-carousel-legend-item main-videos-item"
              >
                {TEXT["sections"]["emotive"][language]}
              </h4>
            </button>
            <button className="noformat-button" onClick={() => toSlide(2)}>
              <h4
                id="carousel-legend-2"
                className="pnud-carousel-legend-item main-videos-item"
              >
                {TEXT["sections"]["placebo"][language]}
              </h4>
            </button>
          </div>
          <div className="pnud-carousel">
            <Row wrap={false}>
              <Col flex="70px" className="pnud-hidden-small">
                <div className="pnud-carousel-button-container pnud-carousel-button-left">
                  <button
                    className="noformat-button pnud-button-vertical-center "
                    onClick={toPrev}
                  >
                    <img
                      src={require("./../../images/icons/carouselLeftArrow.png")}
                      alt="Gold Left Arrow"
                      style={{ perspective: "800px" }}
                    ></img>
                  </button>
                </div>
              </Col>
              <Col flex="auto">
                <Carousel ref={carouselRef}>
                  <div className="pnud-carousel-item-container">
                    <PNUDCarouselVideoCard
                      id={"pnud-carousel-item-1"}
                      title={TEXT["videos"]["informative"]["title"][language]}
                      description={
                        TEXT["videos"]["informative"]["description"][language]
                      }
                      disableFlip={false}
                      videoFileName="informativo.mp4"
                      currentSlide={currentSlide}
                    />
                  </div>
                  <div className="pnud-carousel-item-container">
                    <PNUDCarouselVideoCard
                      id={"pnud-carousel-item-2"}
                      title={TEXT["videos"]["emotive"]["title"][language]}
                      description={
                        TEXT["videos"]["emotive"]["description"][language]
                      }
                      disableFlip={false}
                      videoFileName="emotivo.mp4"
                      currentSlide={currentSlide}
                    />
                  </div>
                  <div className="pnud-carousel-item-container">
                    <PNUDCarouselVideoCard
                      id={"pnud-carousel-item-3"}
                      title={TEXT["videos"]["placebo"]["title"][language]}
                      description={
                        TEXT["videos"]["placebo"]["description"][language]
                      }
                      disableFlip={true}
                      currentSlide={currentSlide}
                      normalPointer={true}
                    />
                  </div>
                </Carousel>
              </Col>
              <Col flex="70px" className="pnud-hidden-small">
                <div className="pnud-carousel-button-container pnud-carousel-button-right">
                  <button
                    className="noformat-button pnud-button-vertical-center "
                    onClick={toNext}
                  >
                    <img
                      src={require("./../../images/icons/carouselRightArrow.png")}
                      alt="Gold Right Arrow"
                    />
                  </button>
                </div>
              </Col>
            </Row>
          </div>
          <p>{TEXT["experiment"]["secondParagraph"][language]}</p>
        </div>
        <div className="pnud-content-section">
          <PNUDSectionTitle text={TEXT["results"]["title"][language]} />
          <div className="pnud-results-title">
            {TEXT["results"]["section2-title"][language]}
          </div>
          <div className="pnud-results-content">
            <PNUDAcceptance textPlacement={"left"} />
            <Divider className="divider-full-screen" />
            <PNUDSocialServices textPlacement={"right"} />
            <Divider className="divider-full-screen" />
            <PNUDEconomicContribution textPlacement={"left"} />
            <Divider className="divider-full-screen" />
            <PNUDDiversity textPlacement={"right"} />
            <Divider className="divider-full-screen" />
            <PNUDCrime textPlacement={"left"} />
          </div>
        </div>
        <div className="pnud-content-section">
          <PNUDSectionTitle
            text={TEXT["videos"]["section"]["title"][language]}
          />
          <div className="pnud-carousel-legend">
            <button className="noformat-button" onClick={handleVideosInfoClick}>
              <h4
                id="carousel-legend-0"
                className="pnud-carousel-legend-item videos-item"
              >
                {TEXT["sections"]["informative"][language]}
              </h4>
            </button>
            <button className="noformat-button" onClick={handleVideosEmoClick}>
              <h4
                id="carousel-legend-1"
                className="pnud-carousel-legend-item videos-item"
              >
                {TEXT["sections"]["emotive"][language]}
              </h4>
            </button>
          </div>
          <div className="pnud-videos-scroll">
            {VIDEOS[selectedVideoType === 0 ? "informative" : "emotive"].map(
              (item, key) => {
                return (
                  <PNUDVideoCard
                    key={key}
                    name={item.name}
                    fileName={item.fileName}
                    thumbnail={selectedVideoType === 0}
                    code={item.code ?? null}
                  />
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
